import Fetch from 'utils/fetch';

/*******************************************************************************
 *
 *   1. Default State
 *   2. Action Types
 *   3. ACtion Creators
 *   4. Reducers
 *
 */

/*******************************************************************************
 *  1. Default State
 */

const updatePasswordState = {	
	errorCode: '',
	errorMessage: ''
};

/*******************************************************************************
 *  2. Action Types
 */
 
const FETCH_PASSWORD_RESET_API = 'fetchPasswordResetApi';
const FETCHED_PASSWORD_RESET_API = 'fetchedPasswordResetApi';

const SUBMIT_PASSWORD_RESET = 'sendUpdatedPassword';
const UPDATED_PASSWORD_RESET = 'updatePasswordReset';

/*******************************************************************************
 *  3. Action Creators
 */
 
 export const fetchPasswordResetApi = () => {
 	return ( dispatch ) => {

        return Fetch( {
            url: FEEDS.APP_PASSWORD_RESET_API,
            dispatch: dispatch,
            type: FETCH_PASSWORD_RESET_API
        } ).then( ( results ) => {
            dispatch( {
                type: FETCHED_PASSWORD_RESET_API,
                data: results.data
            } );
            dispatch( results.fetched );
        } );

    };
 };
 
 export const sendUpdatedPassword = (data) => {
 	return ( dispatch ) => {
        return Fetch( {
            url: FEEDS.APP_PASSWORD_RESET_SUBMIT_API,
			method: 'POST',
            dispatch: dispatch,
            type: SUBMIT_PASSWORD_RESET,
			body: data
        } ).then( ( results ) => {
            dispatch( {
                type: UPDATED_PASSWORD_RESET,
                data: results.data
            } );
            dispatch( results.fetched );
        } );

    };
 };
 

/*******************************************************************************
 *  4. Reducers
 */

export default ( state = updatePasswordState, action ) => {

	switch( action.type ) {
        case FETCHED_PASSWORD_RESET_API:
			return {
                ...state,
                ...action.data,
				errorCode: '',
				errorMessage: ''
			};
			
		case UPDATED_PASSWORD_RESET:
			return {
                ...state,
                ...action.data,
				errorCode: action.data.code,
				errorMessage: action.data.message
			};

		default:
	    	return state;
	}

};



// WEBPACK FOOTER //
// ./src/update-password/update-password-dux.js